<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="150px" class="searchForm">
          <el-row>
            <el-col :span="24">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item :label="$t('storeFeedback.report.serialNo')" prop="reportNo">
                    <el-input v-model.trim="queryCondition.reportNo" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('storeFeedback.storeNo')" prop="storeNo">
                    <el-input v-model.trim="queryCondition.storeNo" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('storeFeedback.storeName')" prop="storeName">
                    <el-input v-model="queryCondition.storeName" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('storeFeedback.feedbackStatus')" prop="processNode">
                    <ic-select :excludes="excludesValue" clearable table="TT_FEEDBACK" :field="fieldValue" v-model="queryCondition.processNode" style="width:100%"></ic-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-collapse-transition>
              <el-col :span="24" v-if="isShow">
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item :label="$t('storeFeedback.dcName')" prop="tmDcId">
                      <ic-select :table-fields="[{table:'BASE',field:'DC'},{table:'TT_FEEDBACK',field:'DIRECT_SUPPLIER'}]" filterable clearable v-model="queryCondition.tmDcId" style="width:100%"></ic-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item :label="$t('storeFeedback.supplier')" prop="tmSupplierId">
                      <el-select :placeholder="$t('BC.sel')" clearable v-model="queryCondition.tmSupplierId" filterable>
                        <el-option v-for="item in supplierLists" :key="item.tmSupplierId" :label="item.supplierName" :value="item.tmSupplierId"></el-option>
                      </el-select>
                      <!-- <ic-select table="BASE" field="PLANT" filterable clearable v-model="queryCondition.tmSupplierId" style="width:100%"></ic-select> -->
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item :label="$t('storeFeedback.problemLevel')" prop="problemLevel">
                      <ic-select clearable table="TT_FEEDBACK_FIRST_CHECK" class="handle-input" field="PROBLEM_LEVEL" v-model="queryCondition.problemLevel" style="width:100%"></ic-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="责任方" prop="finalResponsibleParty">
                      <ic-select clearable table="TT_FEEDBACK_REPORT" class="handle-input" field="FINAL_RESPONSIBLE_PARTY" v-model="queryCondition.finalResponsibleParty" style="width:100%"></ic-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item :label="$t('storeFeedback.materialName')" prop="materialName">
                      <el-input v-model="queryCondition.materialName" clearable style="width:100%"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item :label="$t('storeFeedback.auditor')" prop="auditor">
                      <el-input class="handle-input" v-model.trim="queryCondition.auditor" clearable placeholder="审批人" style="width:100%"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item :label="$t('storeFeedback.feedbackChannel')" prop="sourceCode">
                      <ic-select v-model="queryCondition.sourceCode" clearable table="TT_FEEDBACK" field="QUERY_SOURCE_CODE" style="width:100%"></ic-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="餐厅提交日期(从)" prop="createDateFrom">
                      <el-date-picker v-model="queryCondition.createDateFrom" type="date" :placeholder="$t('common.selDate')" value-format="yyyy-MM-dd" style="width:100%"></el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="餐厅提交日期(至)" prop="createDateTo">
                      <el-date-picker v-model="queryCondition.createDateTo" type="date" :placeholder="$t('common.selDate')" value-format="yyyy-MM-dd" style="width:100%"></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="Category Level1" prop="categoryLevel1Code">
                      <ic-select table="BASE" filterable field="CATEGORY_LEVEL1" clearable @change="queryCondition.categoryLevel2Code=null" v-model="queryCondition.categoryLevel1Code" style="width:100%"></ic-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="Category Level2" prop="categoryLevel2Code">
                      <ic-select table="BASE" filterable multiple :field="queryCondition.categoryLevel1Code" clearable v-model="queryCondition.categoryLevel2Code" style="width:100%"></ic-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="扣账月份从" prop="debitMonthFrom">
                      <el-date-picker v-model="queryCondition.debitMonthFrom" type="month" :placeholder="$t('common.selDate')" value-format="yyyy-MM" format="yyyy-MM" style="width:100%"></el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="扣账月份至" prop="debitMonthTo">
                      <el-date-picker v-model="queryCondition.debitMonthTo" type="month" :placeholder="$t('common.selDate')" value-format="yyyy-MM" format="yyyy-MM" style="width:100%"></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item :label="$t('storeFeedback.report.reportStatus')" prop="reportStatus">
                      <ic-select table="TT_FEEDBACK_REPORT" field="STATUS" :excludes="reportStatusExclude" clearable v-model="queryCondition.reportStatus" style="width:100%"></ic-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-collapse-transition>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" type="primary" @click="queryData(1)">{{$t('common.search')}}</el-button>
            <el-button size="mini" type="primary" @click="resetQueryCondition()">{{$t('common.reset')}}</el-button>
            <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button size="mini" class="btn" type="danger" v-acl="Feedback-reportsDelete" v-if="isSUP" @click="delReport()">{{$t('common.del')}}</el-button>
        <!-- <el-button type="primary" v-acl="FeedbacksDebitsNew"  size="small" v-if="isFBC" @click="AddDebitInfo">{{$t('storeFeedback.report.AddDebitInfo')}}</el-button> -->
        <el-button size="mini" class="btn" type="primary" v-acl="Feedback-reportsDebitsExport" @click="exportExcelDebit">{{$t('storeFeedback.report.debitsExport')}}</el-button>
      </el-row>
      <el-table ref="table" :data="tableData" border max-height='420' highlight-current-row class="table">
        <el-table-column align="center" type="selection" fixed v-if="!isStore"></el-table-column>
        <el-table-column show-overflow-tooltip prop="reportNo" :label="$t('storeFeedback.report.reportNo')" min-width="200px" fixed>
          <template slot-scope="scope">
            <div class="a-link" @click="showDetail(scope.row.ttFeedbackReportId,scope.row)">{{scope.row.reportNo}}</div>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip min-width="180px" prop="supplierName" :label="$t('storeFeedback.supplier')"></el-table-column><!-- 供应商 -->
        <el-table-column show-overflow-tooltip min-width="180px" prop="materialName" :label="$t('storeFeedback.materialName')"></el-table-column><!-- 产品名称 -->
        <el-table-column show-overflow-tooltip min-width="90px" sortable prop="problemLevel" align="center" :label="$t('storeFeedback.problemLevel')"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="90px" sortable prop="finalResponsibleParty" align="center" :label="'责任方'">
          <template slot-scope="scope">{{scope.row.finalResponsibleParty|ic("TT_FEEDBACK_REPORT","FINAL_RESPONSIBLE_PARTY")}}</template>
        </el-table-column>
        <el-table-column show-overflow-tooltip min-width="90px" sortable prop="isRepeat" align="center" :label="$t('storeFeedback.isRepeat')"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="180px" prop="storeName" :label="$t('storeFeedback.storeName')"></el-table-column><!-- 餐厅国际名称-->
        <el-table-column show-overflow-tooltip min-width="100px" prop="processNode" :label="$t('storeFeedback.feedbackStatus')">
          <template slot-scope="scope">{{scope.row.processNode|ic("TT_FEEDBACK",fieldValue)}}</template>
        </el-table-column>
        <el-table-column show-overflow-tooltip min-width="80px" prop="consumeType" :label="$t('storeFeedback.consumeType')">
          <template slot-scope="scope">{{scope.row.consumeType|ic("TT_FEEDBACK","CONSUME_TYPE")}}</template>
        </el-table-column>
        <el-table-column show-overflow-tooltip min-width="80px" prop="firstSubmitDate" :label="$t('storeFeedback.SubmitDate')">
          <template slot-scope="scope">{{scope.row.firstSubmitDate | dateFormatFilter("YYYY-MM-DD")}}</template>
        </el-table-column>
        <el-table-column show-overflow-tooltip min-width="120px" prop="feedbackNo" :label="$t('storeFeedback.report.feedbackNo')"></el-table-column><!-- 问题报告单据编号 -->
        <el-table-column show-overflow-tooltip min-width="80px" prop="dcName" :label="$t('storeFeedback.dcName')"></el-table-column><!-- 发货DC -->
        <el-table-column show-overflow-tooltip min-width="80px" prop="materialCode" :label="$t('storeFeedback.materialCode')"></el-table-column><!-- 货号 -->
        <el-table-column show-overflow-tooltip min-width="70px" prop="sourceCode" :label="$t('storeFeedback.feedbackChannel')">
          <template slot-scope="scope">{{scope.row.sourceCode|ic("TT_FEEDBACK","SOURCE_CODE")}}</template>
        </el-table-column>
        <el-table-column show-overflow-tooltip min-width="130" prop="storeNo" :label="$t('storeFeedback.storeNo')"></el-table-column><!--  餐厅国际编号（7位） -->
        <el-table-column show-overflow-tooltip min-width="70" prop="isDirectSale" :label="$t('storeFeedback.isDirectSale')"><template slot-scope="scope">{{scope.row.isDirectSale|ic("COMMON","YES_NO")}}</template></el-table-column><!-- 是否直营 -->
        <el-table-column show-overflow-tooltip min-width="100" prop="reportStatus" :label="$t('storeFeedback.report.reportStatus')">
          <template slot-scope="scope">{{scope.row.reportStatus|ic("TT_FEEDBACK_REPORT","STATUS")}}</template>
        </el-table-column>
        <el-table-column show-overflow-tooltip min-width="100px" v-if="isSUP || isMCD" prop="supplierCostTime" :label="$t('storeFeedback.supplierCostTime')" align="center">
          <template slot-scope="scope">{{(scope.row.supplierCostTime/60).toFixed(2)}}</template>
        </el-table-column>
        <el-table-column show-overflow-tooltip min-width="100px" v-if="isMCD" prop="storeCostTime" :label="$t('storeFeedback.report.storeTime')">
          <template slot-scope="scope">{{(scope.row.storeCostTime/60).toFixed(2)}}</template>
        </el-table-column>
        <el-table-column show-overflow-tooltip min-width="100px" v-if="isMCD" prop="cqscostTime" :label="$t('storeFeedback.report.mcdOperateTime')">
          <template slot-scope="scope">{{(scope.row.cqscostTime/60).toFixed(2)}}</template>
        </el-table-column>
        <el-table-column show-overflow-tooltip min-width="100px" v-if="isFBC || isMCD" prop="fbccostTime" :label="$t('storeFeedback.report.fbcOperateTime')">
          <template slot-scope="scope">{{(scope.row.fbccostTime/60).toFixed(2)}}</template>
        </el-table-column>
        <el-table-column show-overflow-tooltip min-width="90px" prop="auditor" align="center" :label="$t('storeFeedback.auditor')"></el-table-column><!-- 审批人 -->
        <el-table-column show-overflow-tooltip min-width="120px" prop="categoryLevel1Name" align="center" label="Category Level1"></el-table-column><!-- Level1 -->
        <el-table-column show-overflow-tooltip min-width="120px" prop="categoryLevel2Name" align="center" label="Category Level2"></el-table-column><!-- Level2 -->
        <el-table-column show-overflow-tooltip min-width='100' prop="commitDate" :label="$t('storeFeedback.createDate')">
          <template slot-scope="scope">{{scope.row.commitDate | dateFormatFilter("YYYY-MM-DD")}}</template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount"></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import storeFeedbackApi from "@/api/storeFeedback/storeFeedback";
import reportApi from "@/api/storeFeedback/report";
import { inputChoiceService } from "@/api/common/input-choice";
import { Message } from "element-ui";
import IcSelect from "@/components/common/icSelect";
import commonFunction from "@/utils/dataTableUtils";
import paginationMixin from '@/mixins/pagitionMixin';
import store from '@/store/index'
export default {
  components: { IcSelect },
  extends: commonFunction,
  mixins: [paginationMixin],
  computed: {
    reportStatusExclude() {
      if (this.isStore) {
        return ['REPORT_NEW', 'REPORT_FBC', 'REPORT_MCD', 'REPORT_FBC_POST', 'REPORT_MCD_POST', 'TO_PUBLISH'];
      } else if (this.isFBC || this.isMCD) {
        return ['REPORT_NEW', 'REPORT_FBC_POST'];
      } else {
        return ['REPORT_FBC_POST'];
      }
    }
  },
  data() {
    return {
      isShow: false,//控制查询列表收缩展开
      isStore: false,
      isFBC: false,
      isMCD: false,
      isSUP: false,
      tableData: [],
      supplierLists: [],
      totalCount: 0,
      labelPosition: 'right',
      queryCondition: {
        reportNo: null,
        from: 'report',//调查报告查询列表
        feedbackNo: null,
        storeNo: null,
        storeName: null,
        creator: null,
        tmDcId: null,
        tmSupplierId: null,
        materialCode: null,
        materialName: null,
        sourceCode: null,
        consumeType: null,
        isDirectSale: null,
        reportStatus: null,
        statusList: ['lowerHair'],
        pageNum: 1,
        pageSize: 15,
        storeCostTimeFrom: '',
        supplierCostTimeFrom: '',
        fbccostTimeFrom: '',
        cqscostTimeFrom: '',
        storeCostTimeTo: '',
        supplierCostTimeTo: '',
        fbccostTimeTo: '',
        cqscostTimeTo: '',
        auditor: '',
        categoryLevel1Code: null,
        categoryLevel2Code: null,
        createDateFrom: '',
        createDateTo: '',
        commitDateFrom: '',
        commitDateTo: ''
      },
      applyForm: {
        mateCode: '',
        mateName: '',
        applyCount: 0
      },
      applyDialog: false,
      excludesValue: '',
      fieldValue: 'OTHER_PROCESS_NODE'
    }
  },
  watch: {
    queryCondition() {
      let _this = this;
      store.dispatch('uploadListParams', { routeName: _this.$route.name, reqData: _this.queryCondition })
    }
  },
  beforeRouteEnter(to, from, next) {
    console.log('to', to);
    console.log('from', from);
    if (to.query.tmSupplierId) {
      to.meta.reqData.tmSupplierId = to.query.tmSupplierId
    }
    if (to.query.month) {
      var yyyy = to.query.month.split('-')[0]
      console.log('yyyy', yyyy);
      var mm = to.query.month.split('-')[1]
      console.log('mm', mm);
      var getDate = new Date(yyyy, mm, 0).getDate()
      console.log('1111', getDate);
      if (getDate < 10) {
        getDate = '0' + getDate
      }
      var fromdate = yyyy + '-' + mm + '-01'
      var todate = yyyy + '-' + mm + '-' + getDate
      console.log('fromdate', fromdate);
      console.log('todate', todate);
      to.meta.reqData.createDateFrom = fromdate
      to.meta.reqData.createDateTo = todate
    }
    reportApi.reportsList(to.meta.reqData).then((res) => {
      console.log(res)
      next(vm => {
        vm.queryCondition = to.meta.reqData;
        vm.tableData = res.data.records;
        vm.totalCount = res.data.total;
        if (vm.isStore) {
          vm.tableData.forEach(row => {
            switch (row.processNode) {
              case 'store':
              case 'survey':
              case 'fbcHandle':
              case 'supplierSurvey':
              case 'mcdApproval':
              case 'fbcConfirm':
                row.processNode = "调查中";
                break;
            }
          })
        }
        // if(vm.isStore){
        //     vm.tableData.forEach(row=>{
        //         switch (row.processNode) {
        //             case 'store' :row.processNode = "餐厅发起";
        //                 break;
        //             case 'survey' :row.processNode = "调查中";
        //                 break;
        //             case 'surveyEnd' :row.processNode = "调查结案";
        //                 break;
        //             case 'communicate' :row.processNode = "疑问沟通中";
        //                 break;
        //             case 'finalSettlement' :row.processNode = "最终处理结案";
        //                 break;
        //             case 'suspend' :row.processNode = "中止";
        //                 break;
        //         }
        //     })
        // }
      })
    })
  },
  created() {

    this.getInputChoiceValues();
    // this.queryData(1);
    let roles = JSON.parse(localStorage.getItem("ms_roles"));
    let emplFlag = localStorage.getItem('ms_emplFlag');
    for (let i = 0, len = roles.length; i < len; i++) {
      if (roles[i] == 'SF_STORE_BASIC') {//门店
        this.isStore = true;
        this.excludesValue = ['store'];
      }
      if (roles[i] == 'SF_FBC_BASIC') {//反馈中心
        this.isFBC = true;
        //this.excludesValue = ['store', 'fbcHandle'];
      }
      if (roles[i] == 'SF_MCD_BASIC') {//麦当劳
        this.isMCD = true;
        //this.excludesValue = ['store', 'fbcHandle'];
      }

    }
    if (emplFlag == "SUP") {//供应商
      this.isSUP = true;
      this.excludesValue = ['store', 'fbcHandle'];
    }
    if (!!roles) {
      /*                /!**
                       * Store Feedback:门店用户基本角色
                       *!/
                      public static final String SF_STORE_BASIC = "SF_STORE_BASIC";
                      /!**
                       * Store Feedback:反馈中心用户基本角色
                       *!/
                      public static final String SF_FBC_BASIC = "SF_FBC_BASIC";

                      /!**
                       * Store Feedback:麦当劳用户基本角色
                       *!/
                      public static final String SF_MCD_BASIC = "SF_MCD_BASIC";
                      /!**
                       * Store Feedback:供应商用户基本角色
                       *!/
                      public static final String SF_SUP_BASIC = "SF_SUP_BASIC";    */
      if (roles.indexOf('SF_MCD_BASIC') != -1 || roles.indexOf('SF_FBC_BASIC') != -1 || roles.indexOf('SF_SUP_BASIC') != -1) {
        //非门店用户
      } else if (roles.indexOf('SF_STORE_BASIC') != -1) {
        //门店用户
        this.fieldValue = 'STORE_PROCESS_NODE';
      } else {
        //非门店用户
      }
    }
  },
  mounted() {
    this.getSelection()
  },
  methods: {
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      reportApi.reportsList(this.queryCondition).then(resp => {
        this.tableData = resp.data.records;
        if (this.isStore) {
          this.tableData.forEach(row => {
            switch (row.processNode) {
              case 'store':
              case 'survey':
              case 'fbcHandle':
              case 'supplierSurvey':
              case 'mcdApproval':
              case 'fbcConfirm':
                row.processNode = "调查中";
                break;
            }
          })
        }
        this.totalCount = resp.data.total;
      })
    },
    getSelection() {
      reportApi.getStoreFeedbackDataScopeForPlant().then(res => {
        console.log("🚀 ~ file: reportList.vue:409 ~ reportApi.getStoreFeedbackDataScopeForPlant ~ res:", res)
        if (res.code === '200') {
          this.supplierLists = res.data
        }
      })
    },
    resetQueryCondition() {
      this.$refs['queryCondition'].resetFields();
      this.queryCondition = {
        reportNo: null,
        from: 'report',//调查报告查询列表
        feedbackNo: null,
        storeNo: null,
        storeName: null,
        creator: null,
        tmDcId: null,
        tmSupplierId: null,
        materialCode: null,
        materialName: null,
        sourceCode: null,
        consumeType: null,
        isDirectSale: null,
        reportStatus: null,
        statusList: ['lowerHair'],
        pageNum: 1,
        pageSize: 15,
        storeCostTimeFrom: '',
        supplierCostTimeFrom: '',
        fbccostTimeFrom: '',
        cqscostTimeFrom: '',
        storeCostTimeTo: '',
        supplierCostTimeTo: '',
        fbccostTimeTo: '',
        cqscostTimeTo: '',
        auditor: '',
        categoryLevel1Code: null,
        categoryLevel2Code: null,
        createDateFrom: '',
        createDateTo: '',
        commitDateFrom: '',
        commitDateTo: ''
      }
      this.queryData()
      // this.queryCondition.storeCostTimeFrom = null;
      // this.queryCondition.storeCostTimeTo = null;
      // this.queryCondition.supplierCostTimeFrom = null;
      // this.queryCondition.supplierCostTimeTo = null;
      // this.queryCondition.fbccostTimeFrom = null;
      // this.queryCondition.fbccostTimeTo = null;
      // this.queryCondition.cqscostTimeFrom = null;
      // this.queryCondition.cqscostTimeTo = null;
    },
    delReport() {
      let rows = this.$refs["table"].selection;
      if (rows.length < 1) {
        Message.error(this.$t("common.pleaseSelectData"));
        return;
      }
      for (let i = 0, len = rows.length; i < len; i++) {
        if (rows[i].reportStatus != "REPORT_NEW") {
          Message.error(this.$t("storeFeedback.onlyDraftDeleted"));
          return;
        }
      }
      this.$confirm(this.$t('common.delConfirm'), this.$t('common.tips'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        customClass: 'colorBtn',
        type: 'warning'
      }).then(() => {
        let ids = rows.map(rows => rows.ttFeedbackReportId).join(",");
        reportApi.delFeedbackReport(ids).then(resp => {
          if (resp.code == 200) {
            Message.success(this.$t("common.delSuccess"));
            this.queryData();
          }
        });
      }).catch(() => {

      });


    },
    exportList() {
      reportApi.exportReportsList(this.queryCondition);
    },
    AddDebitInfo() {
      let rows = this.$refs["table"].selection;
      if (rows.length != 1) {
        Message.error(this.$t("common.pleaseSelectOneData"));
        return;
      }
      this.$router.push({
        path: "/feedbackReport/view",
        query: {
          feedbackId: rows[0].ttFeedbackId,
          debitInfo: true,
        }
      })
    },
    showDetail(id, row) {
      if (this.actionCheck.actionCheck('Feedback-reportsDetail') === false) {
        this.$message.error(this.$t('common.noPermission'))
        return false
      }
      let that = this
      let resolve = that.$router.resolve({
        name: `feedbackReportView`,
        query: {
          feedbackReportId: id,
          feedbackId: row.ttFeedbackId,
        }
      });
      window.open(resolve.href, "_blank");
    },
    createNewReport() {
      let rows = this.$refs["table"].selection;
      if (rows.length != 1) {
        Message.error(this.$t("common.pleaseSelectOneData"));
        return;
      }
      this.$router.push({
        name: "createfeedbackReport",
        query: {
          feedbackId: rows[0].ttFeedbackId,
          action: 'create'
        }
      })
      // reportApi.newReportInit(rows[0].ttFeedbackId).then(resp => {
      // });
    },
    getInputChoiceValues() {
      let mapObj = {};
      mapObj["TT_FEEDBACK:STORE_PROCESS_NODE"] = "TT_FEEDBACK:STORE_PROCESS_NODE";
      inputChoiceService.getInputChoiceValues(mapObj).then(res => {
        console.log(res["TT_FEEDBACK:STORE_PROCESS_NODE"])
      });
    },
    exportExcelDebit: function () {
      reportApi.exportExcelDebit(this.queryCondition);
    }
  }
}

</script>
<style scoped  lang="scss">
.reportList {
  .table {
    margin-top: 10px;
  }
  .el-select {
    width: 100%;
  }
  .el-date-editor.el-input {
    width: 100%;
  }
}
</style>
<style lang="scss">
.reportList {
  .flexBox {
    .el-form-item__content {
      display: -moz-box; /* Firefox */
      display: -ms-flexbox; /* IE10 */
      display: -webkit-box; /* Safari */
      display: -webkit-flex; /* Chrome, WebKit */
      display: flexbox;
      display: flex;
      display: flex !important;
    }
  }
}
</style>

